import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';

const HeaderContainer = styled.header`
  background: linear-gradient(135deg, ${props => props.theme.colors.darkBlue} 0%, ${props => props.theme.colors.blue} 100%);
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.spacing.md} 0;
  box-shadow: ${props => props.theme.shadows.md};
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
`;

const LogoIcon = styled.div`
  width: 40px;
  height: 40px;
  background: ${props => props.theme.colors.orange};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: ${props => props.theme.colors.white};
`;

const LogoText = styled.div`
  h1 {
    font-size: 1.5rem;
    margin: 0;
    color: ${props => props.theme.colors.white};
  }
  
  p {
    font-size: 0.9rem;
    margin: 0;
    opacity: 0.9;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: ${props => props.theme.spacing.lg};
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  color: ${props => props.theme.colors.white};
  text-decoration: none;
  font-weight: 500;
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
  border-radius: ${props => props.theme.borderRadius.md};
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &.active {
    background: ${props => props.theme.colors.orange};
  }
`;

const ThemeToggle = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: ${props => props.theme.colors.white};
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: 1.2rem;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const Header: React.FC = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo>
          <LogoIcon>💰</LogoIcon>
          <LogoText>
            <h1>ZUSik</h1>
            <p>Narzędzie edukacyjne</p>
          </LogoText>
        </Logo>
        
        <Nav>
          <NavLink to="/">Strona główna</NavLink>
          <NavLink to="/simulation">Symulacja</NavLink>
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/admin">Admin</NavLink>
        </Nav>
        
        <ThemeToggle onClick={toggleDarkMode} aria-label="Przełącz tryb ciemny">
          {isDarkMode ? '☀️' : '🌙'}
        </ThemeToggle>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
